import l from "./index74.mjs";
import { useContext as t } from "react";
import r from "./index51.mjs";
import { createI18nInstance as a } from "./index24.mjs";
import { getTFuncWithNamespace as i, getUseLocoTranslation as p } from "./index28.mjs";
import { createLocaleProvider as j } from "./index27.mjs";
import { defaultNS as u } from "./index25.mjs";
import { useTranslation as d } from "./index75.mjs";
const f = {
  en: { common: r }
}, s = [u], c = () => s, e = (o) => `frontend_utils.${o}`, N = async (o, m) => l(/* @__PURE__ */ Object.assign({ "./locales/ar/common.json": () => import("./index46.mjs"), "./locales/cs/common.json": () => import("./index47.mjs"), "./locales/da/common.json": () => import("./index48.mjs"), "./locales/de/common.json": () => import("./index49.mjs"), "./locales/el/common.json": () => import("./index50.mjs"), "./locales/en/common.json": () => import("./index51.mjs"), "./locales/es/common.json": () => import("./index52.mjs"), "./locales/fr/common.json": () => import("./index53.mjs"), "./locales/hi/common.json": () => import("./index54.mjs"), "./locales/hu/common.json": () => import("./index55.mjs"), "./locales/id/common.json": () => import("./index56.mjs"), "./locales/it/common.json": () => import("./index57.mjs"), "./locales/ja/common.json": () => import("./index58.mjs"), "./locales/nl/common.json": () => import("./index59.mjs"), "./locales/no/common.json": () => import("./index60.mjs"), "./locales/pl/common.json": () => import("./index61.mjs"), "./locales/pt/common.json": () => import("./index62.mjs"), "./locales/ro/common.json": () => import("./index63.mjs"), "./locales/ru/common.json": () => import("./index64.mjs"), "./locales/sk/common.json": () => import("./index65.mjs"), "./locales/sl/common.json": () => import("./index66.mjs"), "./locales/sq/common.json": () => import("./index67.mjs"), "./locales/sr/common.json": () => import("./index68.mjs"), "./locales/sv/common.json": () => import("./index69.mjs"), "./locales/th/common.json": () => import("./index70.mjs"), "./locales/tr/common.json": () => import("./index71.mjs"), "./locales/uk/common.json": () => import("./index72.mjs"), "./locales/zh/common.json": () => import("./index73.mjs") }), `./locales/${o}/${m}.json`, 4).then((n) => n.default), { i18n: h } = a({
  resources: f
}), { LocaleContext: T, LocaleProvider: _ } = j(), b = i(h.t, c, e), k = p({
  useTranslation: (o, m) => {
    const { i18n: n } = t(T) ?? {};
    return d(o, {
      i18n: n,
      ...m
    });
  },
  defaultNamespaces: s,
  namespaceMapper: c,
  assetKeyMapper: e
});
export {
  T as LocaleContext,
  _ as LocaleProvider,
  h as i18n,
  N as loadLangBundle,
  b as t,
  k as useTranslation
};
